import React, { Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import CircularProgress from '@mui/material/CircularProgress';

import theme from './theme'; 

// Lazy load components
const Home = React.lazy(() => import('./components/Home'));
const VerifMod = React.lazy(() => import('./components/VerificationModality'));
const WithBio = React.lazy(() => import('./components/WithBio'));
const WithFan = React.lazy(() => import('./components/WithFan'));
const AcademicProfile = React.lazy(() => import('./components/AcademicProfile'));
const FaydaProfile = React.lazy(() => import('./components/FaydaProfile'));
const VerifyCallback = React.lazy(() => import('./components/VerifyCallback'));
const VerifyComplete = React.lazy(() => import('./components/VerifyComplete'));
const Scan = React.lazy(() => import('./components/scan'));
const Fetch = React.lazy(() => import('./components/Fetchquiz')); 
// Loading component
const LoadingFallback = () => (
  <div className="flex items-center justify-center min-h-screen">
    <CircularProgress />
  </div>
);

// Debug component to log route changes
const RouteDebug = ({ children }) => {
  console.log('🟡 Current route:', window.location.pathname);
  return children;
};

function App() {
  console.log('🟡 App component mounted');
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <RouteDebug>
          <Suspense fallback={<LoadingFallback />}>
            <AppRoutes />
          </Suspense>
        </RouteDebug>
      </Router>
    </ThemeProvider>
  );
}

function AppRoutes() {
  console.log('🟡 AppRoutes rendering');
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/verifmod" element={<VerifMod />} />
      <Route path="/withbio" element={<WithBio />} />
      <Route path="/withfan" element={<WithFan />} />
      <Route path="/academic-profile" element={<AcademicProfile />} />
      <Route path="/fayda-profile" element={<FaydaProfile />} />
      <Route path="/verify" element={<VerifyCallback />} />
      <Route path="/verify-complete" element={<VerifyComplete />} />
      <Route path="/fetch" element={<Fetch />} />
    </Routes>
  );
}

export default App;
